var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSick1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8 16.5C8 17.3284 8.67157 18 9.5 18H14.5C15.3284 18 16 17.3284 16 16.5C16 15.6716 15.3284 15 14.5 15H9.5C8.67157 15 8 15.6716 8 16.5ZM7.83541 7.82918C7.46493 7.64394 7.01442 7.79411 6.82918 8.16459C6.64394 8.53507 6.79411 8.98558 7.16459 9.17082L8.82295 10L7.16459 10.8292C6.79411 11.0144 6.64394 11.4649 6.82918 11.8354C7.01442 12.2059 7.46493 12.3561 7.83541 12.1708L10.8354 10.6708C11.0895 10.5438 11.25 10.2841 11.25 10C11.25 9.71592 11.0895 9.45622 10.8354 9.32918L7.83541 7.82918ZM16.8354 9.17082C17.2059 8.98558 17.3561 8.53507 17.1708 8.16459C16.9856 7.79411 16.5351 7.64394 16.1646 7.82918L13.1646 9.32918C12.9105 9.45622 12.75 9.71592 12.75 10C12.75 10.2841 12.9105 10.5438 13.1646 10.6708L16.1646 12.1708C16.5351 12.3561 16.9856 12.2059 17.1708 11.8354C17.3561 11.4649 17.2059 11.0144 16.8354 10.8292L15.1771 10L16.8354 9.17082Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSick1);
export default __webpack_public_path__ + "static/media/sick-1.117db7ccfad34d2fc205f623f09af2b6.svg";
export { ForwardRef as ReactComponent };